__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "gasapp-web_gasApp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@adrop/ads-web-sdk", "1.1.4", () => (__webpack_require__.e(35098).then(() => (() => (__webpack_require__(35098))))));
			register("@gasapp/ui", "0.2.151", () => (Promise.all([__webpack_require__.e(59967), __webpack_require__.e(45668), __webpack_require__.e(41917), __webpack_require__.e(50318), __webpack_require__.e(80676)]).then(() => (() => (__webpack_require__(41917))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(59967), __webpack_require__.e(50318), __webpack_require__.e(39476)]).then(() => (() => (__webpack_require__(80919))))));
			register("react", "18.3.1", () => (__webpack_require__.e(59967).then(() => (() => (__webpack_require__(22790))))));
			initExternal(86793);
			initExternal(58934);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};